// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1tNbn","info":"Note_info__eWIm7","note":"Note_note__3MFeN","actions":"Note_actions__3Nf4v"};